<template>
  <main-layout>
    <v-container fluid>
      <div class="mb-2 d-flex align-center">
        <div class="flex-grow-1">
          <v-text-field solo dense hide-details clearable :placeholder="$vuetify.lang.t('$vuetify.common.search')" prepend-inner-icon="mdi-magnify" v-model="search" />
        </div>
        <v-btn depressed tile class="ml-2" color="primary" @click="getItem()">
          {{$vuetify.lang.t('$vuetify.common.search')}}
        </v-btn>
      </div>
      <v-data-table dense
        height="calc(100vh - 212px)"
        :headers="headers"
        :items="items"
        :loading="loading"
        :options.sync="options"
        :footer-props="{'items-per-page-options': [20, 25, 30]}"
        :server-items-length="total">

        <template v-slot:[`item`]="{index, item}">
          <tr>
            <td class="text-left">{{indexOf(index)}}</td>
            <td class="text-left">
              <template v-if="item.created">{{item.created | moment('add', $timezone, 'YYYY-MM-DD HH:mm:ss')}}</template>
              <template v-else>-</template>
            </td>
            <td class="text-center">
              <span :class="{'red--text text--darken-2 font-weight-bold': item.request_type == 2}">{{requestTypeLabel[item.request_type]}}</span>
            </td>
            <td class="text-left">
              <template v-if="item.expected_date">
                <span :class="getDateColor(item.expected_date)">{{item.expected_date | moment('add', $timezone, 'YYYY-MM-DD HH:mm:ss')}}</span>
              </template>
              <template v-else>-</template>
            </td>
            <td class="text-center">
              <v-icon :color="item.device.device_status === 1 ? 'green' : 'grey darken-2'">mdi-checkbox-blank-circle</v-icon>
            </td>
            <td class="text-left">
              <template v-if="item.consult">{{item.consult.user_name}}</template>
              <template v-else>-</template>
            </td>
            <td class="text-left">
              <template v-if="item.consult">{{item.consult.pat_name}}</template>
              <template v-else>-</template>
            </td>
            <td class="text-left">
              <template v-if="item.consult && item.consult.begin_date">{{item.consult.begin_date | moment('add', $timezone, 'YYYY-MM-DD HH:mm:ss')}}</template>
              <template v-else>-</template>
            </td>
            <td class="text-left">
              <template v-if="item.consult && item.consult.end_date">{{item.consult.end_date | moment('add', $timezone, 'YYYY-MM-DD HH:mm:ss')}}</template>
              <template v-else>-</template>
            </td>
            <td class="text-left">
              <template v-if="item.consult && item.consult.begin_date && item.consult.end_date">{{item.consult.end_date | moment('diff', item.consult.begin_date) | durtotime}}</template>
              <template v-else>-</template>
            </td>
            <td class="text-center">
              <v-btn x-small tile light color="yellow" 
                :disabled="item.device.device_status !== 1"
                @click="startVideoCall(item)">
                {{$vuetify.lang.t('$vuetify.common.start')}}
              </v-btn>
            </td>
          </tr>
        </template>
        
      </v-data-table>
    </v-container>
  </main-layout>
</template>

<script>
import debounce from 'lodash/debounce'
import moment from 'moment'
export default {
  methods: {
    indexOf (index) {
      const {page, itemsPerPage} = this.options
      return this.total - ((page - 1) * itemsPerPage + index)
    },
    async getItem () {
      const {sortBy, sortDesc, page, itemsPerPage} = this.options
      let q = {}
      if (this.search) {
        let likestr = `%${this.search}%`
        q.filters = [{or: [
          {name: 'consult', op: 'has', val: {name: 'patient', op: 'has', val: {name: 'pat_name', op: 'like', val: likestr}}},
          {name: 'consult', op: 'has', val: {name: 'user', op: 'has', val: {name: 'user_name', op: 'like', val: likestr}}}
        ]}]
      }

      if (sortBy.length) {
        q.order_by = []
        for (let i=0; i<sortBy.length; i++) {
          q.order_by.push({field: sortBy[i], direction: sortDesc[i] ? 'desc' : 'asc'})
        }
      }
      let params = { page, q: JSON.stringify(q), results_per_page: itemsPerPage }
      let {data} = await this.$http.get('reservations', {params})
      this.total = data.num_results
      this.items = data.objects
    },
    startVideoCall (reservedData) {
      let serial = reservedData.device.serial_name
      this.$router.push({name: 'Monitor', params: {serial}, query: {resv: reservedData.id}})
    },
    getDateColor (reservedDate) {
      const reserved = moment(reservedDate)
      const today = moment()

      let result = 'grey--text text-decoration-line-through'
      if (reserved.isSame(today, 'day')) result = 'yellow--text'
      else if (reserved.isAfter(today, 'day')) result = 'white--text'
      return result
    },
    onDeviceChangeHandler (device) {
      const data = this.items.find(v => v.device.serial_name === device.serial_name)
      if (data) {
        console.log(`update device status: ${data.device.serial_name} ${data.device.device_status}`)
        data.device.device_status = device.device_status
      }
      else console.log(`no device: ${device.serial_name}`)
    }
  },
  watch: {
    options: {
      handler () {
        this.getItem()
      },
      deep: true
    },
    search: debounce(function () {
      this.getItem()
    }, 350)
  },
  mounted () {
    this.$session.$on('device-change', this.onDeviceChangeHandler.bind(this))
  },
  data () {
    return {
      loading: false,
      search: '',
      options: {
        sortBy: ['expected_date'],
        sortDesc: [true],
      },
      total: 0,
      headers: [
        { text: this.$vuetify.lang.t('$vuetify.tvsm.header.seq'), value: 'num', align: 'left', sortable: false },
        { text: this.$vuetify.lang.t('$vuetify.tvsm.header.requestTime'), value: 'created', align: 'left' },
        { text: this.$vuetify.lang.t('$vuetify.tvsm.header.requestType'), value: 'request_type', align: 'center', sortable: false },
        { text: this.$vuetify.lang.t('$vuetify.tvsm.header.reserveTime'), value: 'expected_date', align: 'left' },
        { text: this.$vuetify.lang.t('$vuetify.tvsm.header.status'), value: 'device_status', align: 'center', sortable: false },

        { text: this.$vuetify.lang.t('$vuetify.tvsm.header.userName'), value: 'consult_user_name', align: 'left', sortable: false },
        { text: this.$vuetify.lang.t('$vuetify.tvsm.header.patientName'), value: 'consult_pat_name', align: 'left', sortable: false },
        
        { text: this.$vuetify.lang.t('$vuetify.tvsm.header.startTime'), value: 'consult_begin_date', align: 'left', sortable: false },
        { text: this.$vuetify.lang.t('$vuetify.tvsm.header.endTime'), value: 'consult_end_date', align: 'left', sortable: false },
        { text: this.$vuetify.lang.t('$vuetify.tvsm.header.duration'), value: 'consult_working_time', align: 'left', sortable: false },
        { text: this.$vuetify.lang.t('$vuetify.tvsm.header.videocall'), value: 'vc', align: 'center', sortable: false }
      ],
      items: [],
      requestTypeLabel: {
        '1': this.$vuetify.lang.t('$vuetify.common.requestType.1'), 
        '2': this.$vuetify.lang.t('$vuetify.common.requestType.2')
      }
    }
  }
}
</script>